import React, { useState } from "react";
import { render } from "../common/reactUtils";


interface props {
    header: string;
    text: string;
}

export default function Tooltip(props: props) {

    const [showTooltip, setShowTooltip] = useState(true);

    return (
    <>
        { showTooltip &&
        <div className="search-result__tooltip">
            <div className="search-result__tooltip__header">{props.header}</div>
            <div className="search-result__tooltip__text">{props.text}</div>
            <button className="search-result__tooltip__close-button" onClick={() => { setShowTooltip(false) }} title="Stäng tipsruta"></button>
        </div> 
        }
        { !showTooltip &&
        <div className="search-result__tooltip__open-button-container">
            <button className="search-result__tooltip__open-button" onClick={() => { setShowTooltip(true) }} title="Visa tips"></button> 
        </div>
        }
    </>
    );
}



export const initialize = () => {
    render(<Tooltip
        header={"Hittar du inte det du letar efter?"}
        text={"Använd kategorierna och filtren till vänster för att lättare hitta det du söker."}
    />, "#searchtooltipNo");

    render(<Tooltip
        header={"Hittar du inte det du letar efter?"}
        text={"Välj Rätt-del här för att avgränsa träfflistan."}
    />, "#productlist-tooltip");

    render(<Tooltip
        header={"Tips!"}
        text={"Byt aktivt språk genom att trycka på pilarna."}
    />, "#eob-tooltip");
};